import * as ol from 'openlayers'
import { DataTheme } from 'src/Enums'
import { GeoLayer, AbstractLayer, AbstractLayerOptions } from './Layer'
import { LayerConstructionOptions, layerCopyrights, LayerDescription, LayerGroup, LayerParamsObject, LayerType } from './LayerRegistry'
import { ContextTag } from '../wiki/Wiki'

/**
 * Map layer class that draws the costal location points of interest.
 */
class CostalLocations extends AbstractLayer implements GeoLayer {
  static readonly defaultParams: LayerParamsObject = {
    opacity: 1.0
  }

  constructor (options: LayerConstructionOptions) {
    const defaultOptions: AbstractLayerOptions = {
      layerType: LayerType.COSTAL_LOCATIONS,
      enabled: true,
      minZoom: 4,
      zIndex: Number.MAX_SAFE_INTEGER - 1
    }
    super({ ...defaultOptions, ...options })

    const opacity = options.params?.opacity === undefined ? CostalLocations.defaultParams.opacity : options.params?.opacity

    const poi = options.poi

    const features: ol.Feature[] = []
    if (poi !== undefined) {
      poi.forEach(point => {
        if (point.layer === LayerType.COSTAL_LOCATIONS) {
          let coord: ol.Coordinate = [point.lon, point.lat]
          coord = ol.proj.transform(coord, 'EPSG:4326', 'EPSG:25832')
          const feature = new ol.Feature({
            geometry: new ol.geom.Point(coord),
            type: 'wiki_link',
            key: point.key
          })

          feature.setStyle(new ol.style.Style({
            image: new ol.style.Icon({
              anchor: [0.5, 0.5],
              anchorXUnits: 'fraction',
              anchorYUnits: 'fraction',
              src: 'marker.png'
            })
          }))

          features.push(feature)
        }
      })
    }

    this.olLayer = new ol.layer.Vector({
      visible: this.enabled,
      opacity: opacity,
      source: new ol.source.Vector({
        features: features
      })
    })
  }

  static describe (): LayerDescription {
    return {
      type: LayerType.COSTAL_LOCATIONS,
      name: 'map.layer.costallocations',
      group: LayerGroup.POINTS_OF_INTEREST,
      ordering: 1,
      contextTags: [
        ContextTag.COSTAL_LOCATIONS
      ],
      themes: Object.values(DataTheme),
      capabilitiesUrl: '',
      legendEnabled: false,
      opacityEnabled: true,
      layerCopyright: layerCopyrights.Geo
    }
  }
}

export default CostalLocations
